/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    pairs: {
        menu: {
            index: 'Pairs',
            create: 'New',
            list: 'Pairs'
        },
        table_titles: {
            id: 'ID',
            symbol: 'Symbol',
            exchange: 'Exchange',
            bid_rate: 'Bid Price',
            ask_rate: 'Ask Price',
            is_api_enabled: 'Api Status',
            is_rate_ok: 'Rate health check',
            is_secondary: 'Secondary Pair',
            slippage_amount: 'Slippage ($)',
            slippage_percent: 'Slippage (%)',
            updated_at: 'Last update',
            decimals: 'Decimals',
            setting: 'Edit / Delete',
        },
        edit: 'Edit pair'
    }
}
